import {createAction, createAllActions} from 'web-app/util/redux/typed-action-helpers';

import type {MessageSelectionMode} from './constants';

const domain = 'INBOX_CONVERSATION';

export const {action: showEditBar} = createAction(`${domain}/SHOW_EDIT_BAR`, (visibility: boolean) => ({visibility}));

export const {action: toggleForwardView} = createAction(`${domain}/TOGGLE_FORWARD_VIEW`, (show: boolean) => ({show}));

export const {action: setMessageSelectionMode} = createAction(
    `${domain}/SET_MESSAGE_SELECTION_MODE`,
    ({messageSelectionMode}: {messageSelectionMode: MessageSelectionMode}) => ({
        messageSelectionMode,
    }),
);

export const {action: setMessageForDeletion} = createAction(
    `${domain}/MARK_MESSAGE_FOR_DELETION`,
    (messageId: string, shouldMark: boolean) => ({messageId, shouldMark}),
);

export const {action: setMessageToBeForwarded} = createAction(
    `${domain}/MARK_MESSAGE_TO_BE_FORWARDED`,
    (message: any, shouldMark: boolean) => ({message, shouldMark}),
);

export const {action: clearConversation} = createAction(`${domain}/CLEAR_CONVERSATION`, () => ({}));

export const {
    action: deleteMessages,
    success: deleteMessagesSuccess,
    failed: deleteMessagesFailed,
    aborted: deleteMessagesAborted,
} = createAllActions(
    `${domain}/DELETE_MESSAGE`,
    (messageIds: string[], allMessagesLength: number) => ({messageIds, allMessagesLength}),
    (response: any, messageIds: string[], allMessagesLength: number) => ({response, messageIds, allMessagesLength}),
    (error: Error) => ({error}),
);

export const {
    action: archiveConversation,
    success: archiveConversationSuccess,
    failed: archiveConversationFailed,
    aborted: archiveConversationAborted,
} = createAllActions(
    `${domain}/ARCHIVE_CONVERSATION`,
    (conversationId: string) => ({conversationId}),
    (response: any) => ({response}),
    (error: Error) => ({error}),
);

export const {
    action: leaveConversation,
    success: leaveConversationSuccess,
    failed: leaveConversationFailed,
    aborted: leaveConversationAborted,
} = createAllActions(
    `${domain}/LEAVE_CONVERSATION`,
    (conversationId: string) => ({conversationId}),
    (conversationId: string) => ({conversationId}),
    (error: Error) => ({error}),
);

export const {
    action: unarchiveConversation,
    success: unarchiveConversationSuccess,
    failed: unarchiveConversationFailed,
} = createAllActions(
    `${domain}/UNARCHIVE_CONVERSATION`,
    (conversationId: string) => ({conversationId}),
    (response: any, conversationId: string) => ({response, conversationId}),
    (error: Error) => ({error}),
);

export const {
    action: fetchConversation,
    success: fetchConversationSuccess,
    failed: fetchConversationFailed,
} = createAllActions(
    `${domain}/FETCH_CONVERSATION`,
    (conversationId: string, suppressErrors: boolean, reload?: boolean) => ({conversationId, suppressErrors, reload}),
    (response: any, wasReload: boolean) => ({response, wasReload}),
    (error: Error) => ({error}),
);

export const {
    action: fetchPagedConversation,
    success: fetchPagedConversationSuccess,
    failed: fetchPagedConversationFailed,
} = createAllActions(
    `${domain}/FETCH_PAGED_CONVERSATION`,
    (conversationId: string, cursor: string, suppressErrors: boolean) => ({conversationId, cursor, suppressErrors}),
    (response: any, wasReload: boolean) => ({response, wasReload}),
    (error: Error) => ({error}),
);

export const {
    action: markAsUnread,
    success: markAsUnreadSuccess,
    failed: markAsUnreadFailed,
} = createAllActions(
    `${domain}/MARK_AS_UNREAD`,
    (conversationId: string) => ({conversationId}),
    (conversationId: string) => ({conversationId}),
    (error: Error) => ({error}),
);

export const {
    action: fetchAfterMessageId,
    success: fetchAfterMessageIdSuccess,
    failed: fetchAfterMessageIdFailed,
} = createAllActions(
    `${domain}/FETCH_AFTER_MESSAGE_ID`,
    (conversationId: string, messageId: string, suppressErrors: boolean, reload?: boolean) => ({
        conversationId,
        messageId,
        suppressErrors,
        reload,
    }),
    (response: any, wasReload: boolean) => ({response, wasReload}),
    (error: Error) => ({error}),
);

export const {action: renameConversation} = createAction(
    `${domain}/RENAME_CONVERSATION`,
    (conversationId: string, title: string) => ({
        conversationId,
        title,
    }),
);
